/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_R_CodingInputs */

const en_mk_cmp_r_coding = /** @type {(inputs: Mk_Cmp_R_CodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents for coding work`)
};

const id_mk_cmp_r_coding = /** @type {(inputs: Mk_Cmp_R_CodingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen untuk pekerjaan koding`)
};

/**
* | output |
* | --- |
* | "Agents for coding work" |
*
* @param {Mk_Cmp_R_CodingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_r_coding = /** @type {((inputs?: Mk_Cmp_R_CodingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_R_CodingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_r_coding(inputs)
	return en_mk_cmp_r_coding(inputs)
});